import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['eventButtonExampleButton']

  connect() {
    // Example using events
    this.eventButtonExampleButtonTargets.forEach((button) => {
      button.addEventListener('click', () => {
        button.dispatchEvent(new CustomEvent('lui--button:start-loading'))

        setTimeout(() => {
          // Simulate work
          button.dispatchEvent(new CustomEvent('lui--button:stop-loading'))
        }, 3000)
      })
    })
  }

  simulateWork(event) {
    // Example using data-actions
    console.log('Simulating work')

    const button = event.currentTarget

    // Simulate work and stop loading
    setTimeout(() => {
      button.dataset.loading = false
      // Could also use
      //button.dispatchEvent(new CustomEvent('lui--button:stop-loading'))
    }, 3000)
  }
}
